// Client-side mirror of ACTIVE + TERMINAL stages from backend/modules/intelligence/stages.py.
// Kept in sync by convention (single source of truth is the backend `/intelligence/vocabulary`
// endpoint, but we hardcode a fallback for offline rendering).
export const STAGE_LABELS = {
  repere: "Repéré",
  a_verifier: "À vérifier",
  qualifie: "Qualifié",
  a_contacter: "À contacter",
  premier_contact: "Premier contact",
  reponse: "Réponse reçue",
  rendez_vous: "Rendez-vous",
  diagnostic: "Diagnostic ALTIORA",
  client: "Client actif",
  reference: "Source de référence",
  partenaire: "Partenaire actif",
  non_pertinent: "Non pertinent",
  ne_pas_contacter: "Ne pas contacter",
};

export const ACTIVE_STAGES = [
  "repere", "a_verifier", "qualifie", "a_contacter",
  "premier_contact", "reponse", "rendez_vous", "diagnostic",
  "client", "reference", "partenaire",
];

export const TERMINAL_STAGES = ["non_pertinent", "ne_pas_contacter"];
